<template>
    <div class="page-bg">
      <div class="title-box" @click="goSearch">
        <search-head :isDisabled="true"></search-head>
      </div>
      <div class="search-history-content">
        <goods-show :goodsList="goodsList"></goods-show>
      </div>
    </div>
</template>

<script>
  import searchHead from './components/searchHead'
  import goodsShow from './components/goodsShow'
  import axios from 'axios'
  import apiConfig from '@/api'
    export default {
      name: 'retail-goods',
      props: {
      },
      data () {
        return {
          goodsList: [],
        }
      },
      components:{
        searchHead,
        goodsShow
      },
      created(){
        this.getProducts(this.$route.query.id);
      },
      methods:{
        goSearch() {
          this.$router.push({
            name: 'retail-search',
            query: {},
          });
        },
        getProducts(id) {
          const url = apiConfig.serverAddress + apiConfig.products;
          const restParams = {
            needImgHttps: 1,
            pageNo: 1,
            pageSize: 999,
            categoryId: id
          }
          const headers = {
            'Content-Type': "application/json",
            __TokenAuthorization_UserName_:'admin',
           __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(res => {
            this.goodsList = res.data.data;
          });
        },
      }
    }
</script>


<style scoped>
  .page-bg {
    background: #FFFFFF;
    height: 100%;
  }
  .title-box {
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100px;
  }
  .search-history-content {
    margin-top: 100px;
    flex-grow: 1;
    padding: 32px;
  }
  .history-header {
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #666666;
    letter-spacing: 0;
    line-height: 42px;
    font-weight: 400;
  }
  .icon {
    width: 32px;
    height: 32px;
  }
  .labels {
    display: flex;
    flex-wrap: wrap;
  }

  .label {
    margin-right: 16px;
    background: #ffffff;
    border-radius: 5px;
    padding: 12px 24px;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #333333;
    letter-spacing: 0;
    line-height: 36px;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/goods.vue